import cn from 'classnames'
import { FC, useCallback, useMemo } from 'react'

import { Nullable } from 'clickNgo/models/utils'
import { FormNumberInput, useGetFormDataField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { ITranslationsProps, ITurnoverProps } from '../../models/turnoverProps'

import { tooltipMessage } from './configs'

import styles from './TurnoverEditMode.module.scss'

export const TurnoverEditMode: FC<
  ITranslationsProps & Omit<ITurnoverProps, 'isLargeFormatMode'>
> = ({ turnover, ppsShare, isRetail, turnoverLabelKey = '', ppsShareLabelKey = '' }) => {
  const [retailerTurnover] = useGetFormDataField<Nullable<number>>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.turnover
  )

  const isShowCompletenessWarning = useCallback((currentValue: Nullable<number>) => {
    return currentValue === null
  }, [])

  const handleValidatePpsShare = useCallback(async (formPpsShareValue: Nullable<number>) => {
    if (formPpsShareValue) {
      if (formPpsShareValue < 0) {
        return 'PPSShare should not be lesser then 0'
      }

      if (formPpsShareValue > 100) {
        return 'PPSShare should not be greater then 100'
      }
    }

    return ''
  }, [])

  const tooltipRender = useCallback(() => {
    return <>{tooltipMessage}</>
  }, [])

  const isShowRetailerTurnoverWarning = useMemo(
    () => isRetail && isShowCompletenessWarning(retailerTurnover) && !retailerTurnover,
    [isRetail, isShowCompletenessWarning, retailerTurnover]
  )

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <Tooltip disabled={!isShowRetailerTurnoverWarning} tipContent={tooltipRender}>
            <FormNumberInput
              formKey={PARTNER_BASIC_INFO_FORM_KEY}
              field={partnerBasicInfoFields.turnover}
              label={turnoverLabelKey}
              defaultValue={turnover}
              className={cn({ [styles.warning]: isShowRetailerTurnoverWarning })}
            />
          </Tooltip>
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.fieldInput}>
          <FormNumberInput
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            field={partnerBasicInfoFields.ppsShare}
            label={ppsShareLabelKey}
            defaultValue={ppsShare}
            onValidate={handleValidatePpsShare}
            validationType={ValidationType.ONCHANGE}
          />
        </div>
      </div>
    </div>
  )
}
